/**
 * Italian Translations
 */

export const it = {
  // Common
  continue: "Continua",
  back: "← Indietro",
  next: "Avanti",
  previous: "Precedente",
  submit: "Invia",
  cancel: "Annulla",
  save: "Salva",
  edit: "Modifica",
  delete: "Elimina",
  close: "Chiudi",
  loading: "Caricamento...",
  error: "Errore",
  success: "Successo",
  warning: "Avviso",
  info: "Informazione",
  required: "Obbligatorio",
  optional: "Opzionale",
  
  // Property Valuation Result Storytelling Widget
  // Introduction Section
  propertyStoryIntro: "Scorri verso il basso e scopri le informazioni sulla tua proprietà",
  
  // Chapter 1: The Property
  theProperty: "La Proprietà",
  propertyDescription: "Ogni proprietà ha una storia. Questo appartamento di {living_area}m² a {city} esiste dal {year}.",
  propertyProfile: "Profilo della Proprietà",
  rooms: "Locali",
  historicalContext: "Contesto Storico",
  yearBuilt: "Anno di Costruzione",
  currentCondition: "Condizioni Attuali",
  parking: "Parcheggio",
  
  // Chapter 2: The Location
  theLocation: "La Posizione",
  locationDescription: "La posizione è spesso considerata il fattore più importante nella valutazione immobiliare. Esploriamo ciò che rende speciale la posizione di questa proprietà.",
  landInformation: "Informazioni sul Terreno",
  landType: "Tipo di Terreno",
  egridNumber: "Numero EGRID",
  zoning: "Zonizzazione",
  inForceSince: "In vigore dal",
  
  // Map Controls
  streetView: "Vista Strada",
  satelliteView: "Vista Satellite",
  priceHeatmap: "Mappa Termica dei Prezzi",
  zoningPlan: "Piano di Zonizzazione",
  mapNotAvailable: "Mappa interattiva non disponibile",
  mapLoadError: "Errore nel caricamento della mappa",
  
  // Chapter 3: The Market
  theMarket: "Il Mercato",
  marketDescription: "Comprendere il contesto più ampio del mercato aiuta a mettere in prospettiva il valore della tua proprietà.",
  pricePerM2Comparison: "Confronto Prezzo al m²",
  medianPriceComparison: "Confronto Prezzo Mediano",
  areaVsRegion: "La tua zona vs Regione di Ginevra",
  yourArea: "La Tua Zona",
  genevaRegion: "Regione di Ginevra",
  localMarketTrends: "Tendenze del Mercato Locale",
  averagePrice: "Prezzo Medio Q1 2025",
  transactions: "Transazioni Q1 2025",
  priceTrend: "Tendenza dei Prezzi (2023-2025)",
  regionalContext: "Contesto Regionale",
  regionAverage: "Media Regione Ginevra",
  regionalTransactions: "Transazioni Regionali",
  regionalTrend: "Tendenza Regionale",
  
  // Chapter 4: The Neighborhood
  theNeighborhood: "Il Quartiere",
  neighborhoodDescription: "Il valore di una proprietà è fortemente influenzato da ciò che la circonda. Dalle strutture culturali alle necessità quotidiane, esploriamo ciò che rende speciale questa posizione.",
  nearbyPoi: "Punti di Interesse Nelle Vicinanze",
  artCulture: "Arte & Cultura",
  cafe: "Caffè",
  financial: "Finanziario",
  publicUtility: "Servizio Pubblico",
  environmentalFactors: "Fattori Ambientali",
  roadNoiseDay: "Rumore Stradale (Giorno)",
  roadNoiseNight: "Rumore Stradale (Notte)",
  railwayNoiseDay: "Rumore Ferroviario (Giorno)",
  railwayNoiseNight: "Rumore Ferroviario (Notte)",
  veryHigh: "Molto Alto",
  high: "Alto",
  moderate: "Moderato",
  low: "Basso",
  veryLow: "Molto Basso",
  neighborhoodScores: "Punteggi della Qualità del Quartiere",
  neighborhoodQualityAssessment: "Valutazione della Qualità del Quartiere",
  neighborhoodQuality: "Qualità del Quartiere",
  yourProperty: "La Tua Proprietà",
  genevaAverage: "Media di Ginevra",
  shopping: "Shopping",
  grocery: "Alimentari",
  cultureEntertainment: "Cultura e Intrattenimento",
  diningDrinking: "Ristorazione e Bevande",
  education: "Istruzione",
  wellness: "Benessere",
  healthcare: "Sanità",
  transport: "Trasporti",
  basicAmenities: "Servizi di Base",
  outstandingCategories: "Categorie Eccellenti",
  cultureEntertainmentDesc: "10/10 - Accesso a musei, teatri e luoghi culturali",
  diningDrinkingDesc: "10/10 - Ristoranti e caffè di alta qualità nelle vicinanze",
  educationDesc: "10/10 - Eccellenti scuole e strutture educative",
  areasConsideration: "Aree da Considerare",
  transportDesc: "7/10 - Buone ma limitate opzioni di trasporto",
  healthcareDesc: "6/10 - Alcune strutture sanitarie nelle vicinanze ma specialità limitate",
  
  // Chapter 5: The Value
  theValue: "Il Valore",
  valueDescription: "Ora che abbiamo esplorato la proprietà, la sua posizione, il contesto di mercato e la qualità del quartiere, possiamo presentare una valutazione completa basata su tutti questi fattori.",
  goodConfidence: "Buona Confidenza",
  mediumConfidence: "Confidenza Media",
  lowConfidence: "Bassa Confidenza",
  priceAnalysis: "Analisi dei Prezzi",
  pricePerM2: "Intervallo di Prezzo al m²",
  
  // Property Valuation Result MapDashboard Widget
  price: "Prezzo",
  zoning: "Zonizzazione",
  noise: "Rumore",
  pricePerSquareMeter: "Prezzo per m²",
  estimatedValueRange: "Intervallo di valore stimato",
  confidence: "Affidabilità",
  fullReport: "Rapporto completo",
  share: "Condividere",
  propertyDetails: "Dettagli della proprietà",
  propertyInformation: "Informazioni sulla proprietà",
  livingArea: "Superficie abitabile",
  yearBuilt: "Anno di costruzione",
  marketAnalysis: "Analisi di mercato",
  avgPricePerSquareMeter: "Prezzo medio/m²",
  annualTrend: "Tendenza annuale",
  energyEnvironment: "Energia & Ambiente",
  energyRating: "Classe energetica",
  noiseLevel: "Livello di rumore",
  pointsOfInterest: "Punti di interesse",
  low: "Basso",
  medium: "Medio",
  high: "Alto",
  
  // Property Valuation Widget
  // Step 1: Address Input
  whereProperty: "Dove si trova la sua proprietà?",
  enterAddress: "Inserisci il tuo indirizzo",
  
  // Step 2: Location with Map
  isThisProperty: "È questa la tua proprietà?",
  confirmAddress: "Conferma indirizzo",
  thisIsMyProperty: "Questa è la mia proprietà",
  confirmLocation: "Conferma posizione",
  
  // Step 3b: Apartment Selection
  selectApartment: "Seleziona il tuo appartamento",
  customApartment: "Appartamento personalizzato",
  enterCustomDetails: "Inserisci manualmente i dettagli del tuo appartamento",
  floor: "Piano",
  
  // Step 4: Property Details
  tellAboutProperty: "Parlaci della tua proprietà",
  bedrooms: "Numero di pezzi",
  bathrooms: "Numero di bagni",
  livingArea: "Area abitabile (m²)",
  landArea: "Area del terreno (m²)",
  exactBedrooms: "Numero esatto di pezzi",
  exactBathrooms: "Numero esatto di bagni",
  condition: "Condizione",
  needsRenovation: "Necessita di ristrutturazione",
  wellMaintained: "Ben mantenuto",
  newOrRenovated: "Nuovo o recentemente ristrutturato",
  constructionYear: "Anno di costruzione",
  regblPrefillData: "Precompiliamo i dati utilizzando il Registro federale degli edifici e delle abitazioni (REA) quando possiamo. Si prega di verificare i dettagli.",
  
  // Step 5: Valuation Purpose
  valuationPurpose: "Qual è lo scopo della tua valutazione?",
  sellingSoon: "Vendere presto",
  justCurious: "Solo curiosità",
  buyingSoon: "Acquistare presto",
  refinancing: "Rifinanziamento",
  whenSelling: "Quando prevedi di vendere?",
  asap: "Il prima possibile",
  within3months: "Entro 3 mesi",
  threeToSixMonths: "3-6 mesi",
  sixToTwelveMonths: "6-12 mesi",
  justExploring: "Sto solo esplorando le opzioni",
  whatPrice: "A che prezzo stimi questa proprietà?",
  helpUnderstand: "Questo ci aiuta a capire le tue aspettative ma non influisce sulla valutazione.",
  
  // Step 6: Loading/Processing
  processingData: "Elaborazione dei dati della tua proprietà",
  pleaseWait: "Attendere mentre il nostro modello analizza la proprietà...",
  analyzingLocation: "Analisi dei dati sulla posizione",
  findingComparables: "Ricerca di proprietà comparabili",
  calculatingTrends: "Calcolo delle tendenze di mercato",
  finalizingValuation: "Finalizzazione della valutazione",
  
  // Step 7: Contact Information
  valuationReady: "La tua valutazione è pronta!",
  provideContact: "Fornisci i tuoi dati di contatto per ricevere il rapporto di valutazione della proprietà",
  fullName: "Nome completo",
  yourName: "Il tuo nome",
  emailAddress: "Indirizzo email",
  yourEmail: "La tua email",
  phoneNumber: "Numero di telefono",
  yourPhone: "Il tuo telefono",
  title: "Titolo",
  mr: "Sig.",
  mrs: "Sig.ra",
  ms: "Sig.na",
  firstName: "Nome",
  lastName: "Cognome",
  comment: "Commenti aggiuntivi (opzionale)",
  yourComment: "Raccontaci di più sulle tue esigenze",
  agreeReceive: "Accetto di essere contattato per domande o ulteriori informazioni e confermo di aver avuto l'opportunità di consultare",
  privacyPolicy: "l'informativa sulla privacy",
  getValuation: "Ottieni la mia valutazione",
  
  // Step 8: SMS Verification
  verifyPhone: "Verifica il tuo numero di telefono",
  sentCode: "Abbiamo inviato un codice a 4 cifre al tuo telefono. Inseriscilo di seguito per verificare il tuo numero.",
  didntReceive: "Non hai ricevuto un codice?",
  resendCode: "Reinvia codice",
  verifyView: "Verifica e visualizza i risultati",
  
  // Step 8b: SMS code verification
  processingSmsCode: "Elaborazione del codice SMS",
  pleaseWaitSmsCode: "Attendi mentre verifichiamo il tuo numero di telefono...",
  
  // Step 9: Appraisal Result
  propertyValuation: "Valutazione della tua proprietà",
  estimatedRange: "Intervallo stimato:",
  confidence: "Confidenza:",
  low: "Bassa",
  medium: "Media",
  high: "Alta",
  valuationBased: "Questa valutazione è basata su vendite comparabili recenti, tendenze di mercato e i dettagli della proprietà che hai fornito.",
  downloadReport: "Vedi rapporto",
  contactAgent: "Contatta agente",
  startNew: "Inizia una nuova valutazione",
  
  // Validation messages
  invalidEmail: "Inserisci un indirizzo email valido",
  invalidPhone: "Inserisci un numero di telefono valido",
  requiredField: "Questo campo è obbligatorio",
  minCharacters: "Inserisci almeno {{min}} caratteri",
  maxCharacters: "Inserisci al massimo {{max}} caratteri",
  minValue: "Inserisci un valore maggiore o uguale a {{min}}",
  maxValue: "Inserisci un valore minore o uguale a {{max}}",
  
  // Error messages
  errorFetchingAddresses: "Errore nel recupero degli indirizzi. Riprova più tardi.",
  errorFetchingBuilding: "Errore nel recupero dei dettagli dell'edificio. Riprova più tardi.",
  errorVerifyingCode: "Errore nella verifica del codice. Riprova più tardi.",
  errorSubmittingValuation: "Errore nell'invio della valutazione. Riprova più tardi.",
  
  // Mortgage Calculator Widget
  calculateMortgage: "Calcola Mutuo",
  propertyPrice: "Prezzo della proprietà",
  downPayment: "Acconto",
  interestRate: "Tasso di interesse",
  loanTerm: "Durata del prestito",
  monthlyPayment: "Rata mensile",
  totalInterest: "Interessi totali",
  totalPayment: "Pagamento totale",
  amortizationSchedule: "Piano di ammortamento",
  payment: "Pagamento",
  principal: "Capitale",
  interest: "Interesse",
  balance: "Saldo",
  
  // Property Listings Widget
  searchProperties: "Cerca proprietà",
  propertyType: "Tipo di proprietà",
  priceRange: "Fascia di prezzo",
  sortBy: "Ordina per",
  filterResults: "Filtra risultati",
  noResults: "Nessun risultato trovato",
  showing: "Visualizzazione di {{count}} risultati",
  viewMore: "Vedi altro",
  contactForViewing: "Contatta per una visita",
  
  // Property types
  apartment: "Appartamento",
  house: "Casa",
  chalet: "Chalet",
  duplex: "Duplex",
  villa: "Villa",
  
  // Room formatting
  roomsFormat: "{{rooms}} stanze, {{bathrooms}} bagn{{bathrooms_plural}}",
  bathrooms_plural_0: "i",
  bathrooms_plural_1: "o",
  bathrooms_plural_n: "i",
  
  // Property conditions (matching API values)
  good_condition: "Buone condizioni",
  needs_renovation: "Necessita di ristrutturazione",
  new_renovated: "Nuovo o recentemente ristrutturato",
};